export const CommonSweetAlertVariants = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
};
